import React from 'react';
import { baseRealEstateUrl } from '@capcenter/shared';
import { toTitleCase } from '../../../utilities/util';
import { stateMap } from '../../Map/MapUtilities';
import './breadCrumb.scss';

interface BreadCrumbProps {
	city: string,
	county: string,
	state: string,
	postalCode: string,
}

const BreadCrumbDelimiter = () => {
	return <>
		&nbsp;
		/
		&nbsp;
	</>;
};

const BreadCrumb = ({ city, county, state, postalCode }: BreadCrumbProps) => {
	return <div className='breadcrumb--container'>
		{state && <a href={`${baseRealEstateUrl}/homes/location/state/${stateMap[state as string].toLowerCase()}`}>{toTitleCase(stateMap[state])}</a>}
		{county &&
			<>
				<BreadCrumbDelimiter />
				<a href={`${baseRealEstateUrl}/homes/location/county/${county.toLowerCase()}-${state.toLowerCase()}`}>{toTitleCase(county)}</a>
			</>
		}
		{city &&
			<>
				<BreadCrumbDelimiter />
				<a href={`${baseRealEstateUrl}/homes/location/city/${city.toLowerCase()}-${state.toLowerCase()}`}>{toTitleCase(city)}</a>
			</>
		}
		{postalCode &&
			<>
				<BreadCrumbDelimiter />
				<a href={`${baseRealEstateUrl}/homes/location/postal-code/${postalCode}`}>{toTitleCase(postalCode)}</a>
			</>
		}
	</div>;
};
export { BreadCrumb };
